import * as React       from "react";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

export const SyncSubscriptions = ({}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ({isInternalUser, apis, session}) => (
        isInternalUser && (
            <div className="card internal">
                <div className="display">
                    <div className="label" xd-qa-type="label" xd-qa-name="Internal Use Only">
                        Internal Use Only
                    </div>
                    <div
                        className="value"
                    >
                        <button
                            className="sync"
                            onClick={async () => {
                                await apis.next.subscription.sync()
                                await session.reload();
                            }}
                            xd-qa-type="button"
                            xd-qa-name="SYNC SUBX DATA"
                        >
                            SYNC SUBX DATA
                        </button>
                    </div>
                </div>
            </div>
        )
    )
)